export const I18N_NORA_NAMESPACE = 'nora'
